module.exports = __webpack_public_path__ + "static/media/Analyticss.735288df.png";